import { useQuery } from "@tanstack/react-query"

import userApi from "./userApi"

const useUserQuery = () => {
  const { data } = useQuery(["userApi.accountInfo"], userApi.accountInfo)

  return data
}

export default useUserQuery
